module.exports = __webpack_public_path__ + "img/language.a640e07d.png";